package kz.dentalcrm.app.screens.services.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface AddServiceViewEvent : ViewEvent {

    data class AddService(
        val naming: String,
        val description: String,
        val duration: String,
        val price: String
    ) : AddServiceViewEvent

    data class CategorySelected(
        val category: ServiceCategory
    ) : AddServiceViewEvent
}